(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["destacadakk"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('kmarilla-featured-product')) {
  customElements.define('kmarilla-featured-product', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const config = { signal: this.controller.signal };
      this.track = this.querySelector('[data-gallery]');
      this.slides = [...this.querySelectorAll('[data-image-id].kmarilla-featured__slide')];
      this.selectors = [...this.querySelectorAll('[data-product-option]')];
      this.variantSelect = this.querySelector('select[name="id"]');
      this.variants = this.variantSelect ? [...this.variantSelect.options] : [];
      if (this.variantSelect && this.selectors.length) {
        this.querySelector('[data-option-boxes]').hidden = false;
        this.querySelector('[data-variant-fallback]').hidden = true;
        this.selectors.forEach((select, index) => {
          select.value = this.variantSelect.selectedOptions[0]?.dataset['option-' + index] || select.value;
        });
        this.addEventListener('change', event => {
          if (event.target.matches('[data-product-option]')) this.updateVariant();
        }, config);
        this.updateVariant();
      }
      this.querySelector('form')?.addEventListener('submit', event => {
        if (this.variantSelect && !this.variantSelect.value) event.preventDefault();
      }, config);
      this.querySelector('[data-gallery-controls]')?.removeAttribute('hidden');
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.goTo(this.currentSlide() - 1), config);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.goTo(this.currentSlide() + 1), config);
      this.track?.addEventListener('scroll', () => this.updateGallery(), { ...config, passive: true });
      this.track?.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.goTo(this.currentSlide() + (event.key === 'ArrowRight' ? 1 : -1));
      }, config);
      this.resizeObserver = new ResizeObserver(() => this.updateGallery());
      if (this.track) this.resizeObserver.observe(this.track);
      this.updateGallery();
    }
    currentSlide() {
      return this.track?.clientWidth ? Math.round(this.track.scrollLeft / this.track.clientWidth) : 0;
    }
    goTo(index) {
      if (!this.track) return;
      index = Math.max(0, Math.min(index, this.slides.length - 1));
      this.track.scrollTo({ left: index * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    updateGallery() {
      const index = this.currentSlide();
      const counter = this.querySelector('[data-counter]');
      if (counter) counter.textContent = (index + 1) + ' / ' + this.slides.length;
      const prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]');
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= this.slides.length - 1;
    }
    updateVariant() {
      const variant = this.variants.find(item => this.selectors.every((select, index) => item.dataset['option-' + index] === select.value));
      const button = this.querySelector('[data-buy-button]');
      this.variantSelect.value = variant ? variant.value : '';
      const available = variant?.dataset.available === 'true';
      button.disabled = !available;
      button.querySelector('[data-button-label]').textContent = !variant ? 'No disponible' : available ? button.dataset.label : 'Agotado';
      this.querySelector('[data-variant-status]').textContent = !variant ? 'Esta combinación no está disponible. Elige otro color o tarjeta de memoria.' : !available ? 'Esta combinación está agotada.' : '';
      this.querySelector('[data-price]').textContent = variant ? variant.dataset.price : 'No disponible';
      const compare = this.querySelector('[data-compare]');
      compare.textContent = variant?.dataset.compare || '';
      compare.hidden = !variant?.dataset.compare;
      if (variant?.dataset.imageId) {
        const index = this.slides.findIndex(slide => slide.dataset.imageId === variant.dataset.imageId);
        if (index >= 0) this.goTo(index);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
